import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-event-not-found-component',
  standalone: true,
  imports: [TranslateModule, FooterComponent, RouterModule],
  templateUrl: './event-not-found.component.html',
  styleUrl: './event-not-found.component.scss'
})
export class EventNotFoundComponent {

}
